(function () {
  var elms = document.getElementsByClassName("splide");
  for (var i = 0; i < elms.length; i++) {
    new Splide(elms[i]).mount();
  }
})();
document.addEventListener("DOMContentLoaded", function () {
  // Warten, bis die Seite geladen ist
  const badge = document.querySelector(".jdgm-prev-badge__text");
  const stars = document.querySelector(".jdgm-prev-badge__stars");
  const ques = document.querySelectorAll("span.jdgm-qa-badge > span"); 
  const tabsContainer = document.querySelector(".tabs-v3");
  const tabPanel = document.getElementById("tab1Panel7");
  const tabControl = document.getElementById("tab-tab1Panel7");

  if (stars && badge && tabsContainer && tabPanel) {
    // Funktion für den gemeinsamen Klick
    const handleClick = function (event) {
      event.preventDefault();

      // Erstes Scrollen zum Tab-Bereich
      tabsContainer.scrollIntoView({ behavior: "smooth" });

      // Leicht verzögerter Abstand zum Tab-Bereich, um die finale Position zu setzen
      setTimeout(function () {
        window.scrollBy(0, -150); // Scrollt 150px nach oben
      }, 500); // Anpassung der Verzögerung, falls nötig

      // Entfernen der Klasse 'active' und Hinzufügen der Klasse 'th8-hide' bei allen Panels
      const allPanels = document.querySelectorAll(".tabs-v3__panel");
      allPanels.forEach(panel => {
        panel.classList.remove("active");
        panel.classList.add("th8-hide");
      });

      // Entfernen der Klasse 'th8-hide' und Hinzufügen der Klasse 'active' beim spezifischen Panel
      tabPanel.classList.remove("th8-hide");
      tabPanel.classList.add("active");

      // Setzen von aria-selected auf false bei allen tabs-v3__control Elementen und true für das spezifische Tab
      const allTabControls = document.querySelectorAll(".tabs-v3__control");
      allTabControls.forEach(control => control.setAttribute("aria-selected", "false"));

      // Setzen von aria-selected auf true für das spezifische Tab
      tabControl.setAttribute("aria-selected", "true");
    };

    // Hover-Effekt für das Badge hinzufügen
    badge.style.cursor = "pointer";
    badge.addEventListener("mouseover", function () {
      badge.style.textDecoration = "underline";
    });
    badge.addEventListener("mouseout", function () {
      badge.style.textDecoration = "none";
    });

    // Klick-Ereignis für Badge und Sterne
    badge.addEventListener("click", handleClick);
    stars.addEventListener("click", handleClick);
    //ques.addEventListener("click", handleClick);
  }
});
document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('custom-popup');
  const closeButton = document.getElementById('close-popup');

    if (!popup || !closeButton) {
    return; // Funktion abbrechen, wenn das Popup oder der Close-Button nicht existiert
  }
  
  const popupShown = sessionStorage.getItem('popupShown');
  if (!popupShown) {
    popup.style.display = 'flex';
    sessionStorage.setItem('popupShown', 'true');
  }

  closeButton.addEventListener('click', function () {
    popup.style.display = 'none';
  });
});
